import { createRoot, render, useState } from '@wordpress/element';

const App = ( { attributes } ) => {
	const { 
		videoUrl,
		isPlayButton,
		url,
        alt,
        id,
	} = attributes;

	const [isOpen, setOpen] = useState(false);

	const closeModal = () => {
		setOpen(false);
	};

	return (
		<div className="flywp-blocks-customer-feature">
			<div className="wp-block-flywp-gblocks-video-popup-inner">
				<div className="flywp-video-popup-thumbnail">
					
					<img
						src={ url }
						alt={ alt }
						data-id={ id }
						
					/>
					{ isPlayButton && (
						<button className="flywp-video-play-button" onClick={() => setOpen(true)}>
							<svg width="152" height="153" viewBox="0 0 152 153" fill="none" xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="76.0011" cy="76.5409" rx="75.6485" ry="75.6561" fill="white"/>
								<path d="M98.4182 74.605C99.9083 75.4654 99.9083 77.6162 98.4182 78.4766L66.4678 96.925C64.9776 97.7855 63.1147 96.71 63.1147 94.9893L63.1147 58.0924C63.1147 56.3716 64.9776 55.2961 66.4678 56.1566L98.4182 74.605Z" fill="#0061FF"/>
							</svg>

						</button>
					) }
				</div>
				
			</div>

			{ isOpen && (
				<div className="flywp-video-modal-popup">
					<div className="flywp-video-modal-popup-body">
						<button className="close" onClick={closeModal}>⤬</button>
						<div className="flywp-video-modal-popup-iframe">
							<iframe
								src={ videoUrl }
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
								loading="lazy"
							></iframe>
						</div>
					</div>
				</div>
			) }
		</div>
	);
};

const mountWrap = document.querySelector('.wp-block-wedocs-gblocks-video-modal');
const blockAttributes = mountWrap.getAttribute('data-block-attributes');

if (createRoot) {
	createRoot(mountWrap).render(
		<App attributes={JSON.parse(blockAttributes)} />
	);
} else {
	render(
		<App attributes={JSON.parse(blockAttributes)} />,
		mountWrap
	);
}